/**
 * 제품코드 표시 유틸 — 검색영역의 발급제품 MultiSelect 용
 *
 * 배경
 *   기존에는 각 화면(ListNoRequest / LicenseOldAndNewMain)에 제품 목록이 하드코딩되어
 *   있었다. 그 결과 CODE_MANAGEMENT 에 등록된 제품 24건 중 7건이 검색영역에서 누락됐다
 *   (렉스퍼트 2.5 / 한글로폼 / 한글로젠 / 마그넷X / 데몬 / exePrint / RexESP).
 *
 * 방식
 *   목록은 DB(CODE_MANAGEMENT.PROD_CODE)에서 받아오고, 약어만 아래 표로 붙인다.
 *   - 표에 없는 코드는 CODE_NAME(풀제품명)이 그대로 표시된다 → 제품이 추가돼도 화면 수정 불필요
 *   - 화면 노출 제어는 DB 의 USE_YN / DEL_YN 으로 한다. 폐기 제품은 DB 에서 끄면 자동으로 빠진다
 *   - 약어는 짧아서 알아보기 어렵기 때문에 풀제품명을 name 에 담아 툴팁으로 노출한다
 */

/** 제품코드 → 약어. 없으면 CODE_NAME 을 그대로 쓴다. */
export const PROD_ABBR = {
    CLIP00000: 'R2.5',
    CLIP00001: 'R3',
    CLIP00002: 'R4',
    CLIP00003: 'E2.5',
    CLIP00004: 'E4',
    CLIP00005: 'R5',
    CLIP00006: 'E5',
    CLIP00007: 'R6',
    CLIP00008: 'E6',
    CLIP00009: 'DE6',
    CLIP00010: 'D6',
    // 6.0 상세기능
    CLIP00015: 'REPO',
    CLIP00016: 'MIRR',
    CLIP00017: 'CHAT',
    CLIP01001: 'Unify',
    CLIP02001: 'CodeX',
    CLIP02002: 'CodeV',
    CLIP03001: 'MirrorLink',
    // 아래 제품들은 약어를 두지 않고 제품명을 그대로 노출한다
    //   CLIP00013 한글로폼 / CLIP00014 한글로젠
    //   CLIP00021 마그넷X / CLIP00022 데몬 / CLIP00023 exePrint / CLIP00024 RexESP
};

/**
 * RE6 는 DB 제품코드가 아니라 CLIP00007 + CLIP00008 조합을 뜻하는 논리 토큰이다.
 * 매퍼의 필터 조건에서 해석된다 (BizLicenseMapper / BizLicenseOldMapper).
 */
export const PROD_TOKEN_RE6 = {
    label: 'RE6',
    name: '클립리포트 6.0 + 클립이폼 6.0',
    value: 'RE6'
};

/**
 * $code(["PROD_CODE"]) 응답을 검색영역 MultiSelect 옵션으로 변환한다.
 *
 * @param {Array} list result.prodCode — [{ label: CODE_NAME, value: CODE, codeSort }]
 * @returns {Array} [{ label: 약어또는제품명, name: 풀제품명(툴팁), value: 제품코드 }]
 */
export function toProdOptions(list) {
    var out = [];
    (list || []).forEach(function (p) {
        // CLIP02002 처럼 DB 값에 뒤쪽 공백이 붙은 코드가 있다.
        // 약어 조회는 trim 한 값으로 하되, value 는 DB 원본을 그대로 유지해야
        // FIND_IN_SET 조건이 어긋나지 않는다.
        var code = (p.value || '').trim();
        out.push({
            label: PROD_ABBR[code] || p.label,
            name: p.label,
            value: p.value
        });
        // 이폼 6.0 뒤에 리포트+이폼 조합 토큰을 끼워 넣는다
        if (code === 'CLIP00008') {
            out.push(PROD_TOKEN_RE6);
        }
    });
    return out;
}

/** 제품코드로 풀제품명을 찾는다. optionValue 를 쓰는 MultiSelect 의 칩 툴팁용. */
export function prodNameOf(options, value) {
    var hit = (options || []).filter(function (o) { return o.value === value; })[0];
    return hit ? hit.name : value;
}
